import router from '@/router/index'
import VectorService from '@/services/vector.service'
import store from '@/store/index'
import { Action, Module, Mutation, VuexModule, getModule } from 'vuex-module-decorators'
import alertsModule from './alerts.module'
import devicesModule from './devices.module'
import globalModule from './global.module'
import mapsModule from './maps.module'
import JwtUserDto from '@/models/dto/JwtUser.dto'
import reportsModule from './reports.module'
import notificationsModule from './notifications.module'
import geofencesModule from './geofences.module'

@Module({ dynamic: true, store, name: 'global' })
class Global extends VuexModule {

  isLoading? = true
  nowTime: Date = new Date()
  rasterActive = true
  mapLayer = 'ostm'

  user: JwtUserDto = {
    id: 0,
    name: 'NaN',
    token: '',
    attributes: {}
  }

  reportLoader = {
    visible: false,
    text: 'Buscando Posiciones...'
  }

  generatePdfLoader = {
    visible: false,
    text: 'Generando PDF...',
    success: false,
  }

  get userTxControl(){
    return this.user.attributes.services?.txControl ?? false
  }

  @Mutation
  setMapLayer(newVal: string): void {
    this.mapLayer = newVal
  }

  @Mutation
  updateLoading(newVal: boolean): void {
    this.isLoading = newVal
  }

  @Mutation
  setRaster(newVal: boolean): void {
    this.rasterActive = newVal
  }

  @Mutation
  setUser(newUser: any): void {
    this.user = newUser
  }

  @Mutation
  refreshTime(): void {
    this.nowTime = new Date()
  }

  @Mutation
  updateBodySize() {
    const body: any = document.getElementsByClassName('body')
    body[0].style.height = `${window.innerHeight - 65 - 60}px`
  }

  @Action({ commit: 'updateLoading' })
  setLoading(newVal: boolean): boolean {
    return newVal
  }

  @Action
  async Init() {
    globalModule.updateLoading(true)
    await devicesModule.getDevices()
    await devicesModule.getPositions()
    await alertsModule.getEvents()
    await notificationsModule.getAllNotifications()
    await geofencesModule.getAllGeofences()
    mapsModule.mapService.updateIconsDevices()
    mapsModule.mapService.updateRasterDevices()
    mapsModule.mapService.updateGeofences()
    VectorService.centerFeaturesByLayer(5)
    this.loadPreferences()
    globalModule.updateLoading(false)
    setInterval(() => {
      this.Update();
    }, process.env.VUE_APP_REFRESH_TIME_MILLISECONDS);
  }

  @Action
  loadPreferences(){
    const preferences = this.user.attributes?.preferences;
    this.setMapLayer(preferences?.mapLayer || 'ostm')
    reportsModule.setShowGuides(preferences?.showGuidesReport ?? true)
    alertsModule.setSoundActive(preferences?.sound ?? true)
    this.setRaster(preferences?.showRaster ?? true)
  }

  @Action
  async Update() {
    await devicesModule.getPositions()
    await alertsModule.getNewEvents()
    mapsModule.mapService.updateIconsDevices()
    mapsModule.mapService.updateRasterDevices()
  }

  @Action
  setRouter(to: string) {
    router.push(to).catch(error => {
      if (error.name != "NavigationDuplicated") {
        throw error;
      }
    });
  }

}

export default getModule(Global);